import React from 'react';
import { DetailPanelData } from '../../../Common/DetailPanel';
import UserInfo from '../../../../UserInfo';

const GeneralInformation = ({
    data: {
        locationOnSite = '',
        sublocationName = '',
        locationCountry = '',
        locationState = ''
    } = {},
    aliases
}) => {
    return (
        <>
            {sublocationName !== '' && <DetailPanelData id='SublocationHeader' title="SUBLOCATION" data={sublocationName} />}
            <DetailPanelData id='CountryHeader' title="Country" data={locationCountry} />
            <DetailPanelData id='AssetAlias' title="ALIAS / EXTERNAL ID" data={aliases} isClickable={UserInfo.isNativeAdminRole()} />
            {locationOnSite !== '' && <DetailPanelData id='LocationOnSiteHeader' title="LOCATION ON SITE" data={locationOnSite} />}
            <DetailPanelData id='StateHeader' title="STATE" data={locationState} />
        </>
    )
}

export default GeneralInformation;